export default __webpack_public_path__ + "static/GRID2022 Stock IDPs0-24 RGBlight - Simplify-01-115e6d171b937307e6e7ec12c7ae2af7.svg";